/** Codes pays GIMAC (champ `code` à la racine de /gimacpay/countries) */
export type GimacCountryCode = 'HC' | 'GH' | 'GQ' | 'TD' | 'CF' | 'CG' | 'GA' | 'CM';

export interface GimacCountryMeta {
  countryIsoCode: string;
  dialCode: string;
  flag: string;
}

export const GIMAC_COUNTRY_CONFIG: Record<GimacCountryCode, GimacCountryMeta> = {
  CM: { countryIsoCode: 'CMR', dialCode: '237', flag: '🇨🇲' },
  GA: { countryIsoCode: 'GAB', dialCode: '241', flag: '🇬🇦' },
  CG: { countryIsoCode: 'COG', dialCode: '242', flag: '🇨🇬' },
  TD: { countryIsoCode: 'TCD', dialCode: '235', flag: '🇹🇩' },
  CF: { countryIsoCode: 'CAF', dialCode: '236', flag: '🇨🇫' },
  GQ: { countryIsoCode: 'GNQ', dialCode: '240', flag: '🇬🇶' },
  GH: { countryIsoCode: 'GHA', dialCode: '233', flag: '🇬🇭' },
  HC: { countryIsoCode: 'HCM', dialCode: '', flag: '🌍' },
};

export const getGimacCountryDialCode = (countryCode: string): string =>
  GIMAC_COUNTRY_CONFIG[countryCode as GimacCountryCode]?.dialCode ?? '';

export const getGimacCountryFlag = (countryCode: string): string =>
  GIMAC_COUNTRY_CONFIG[countryCode as GimacCountryCode]?.flag ?? '';

export type GimacParticipantType = 'BANK' | 'MM' | 'MNO' | 'FINTECH' | 'MNOS' | string;

export const GIMAC_MOBILE_MONEY_TYPES: GimacParticipantType[] = ['MM', 'MNO'];

export interface GimacParticipant {
  code: string;
  shortName: string;
  name: string;
  type: GimacParticipantType;
  enabled: boolean;
  countryCode: string;
  countryIsoCode: string | null;
}

export const isGimacMobileMoneyParticipant = (participant: GimacParticipant): boolean =>
  GIMAC_MOBILE_MONEY_TYPES.includes(participant.type) && participant.enabled;

export interface GimacTelco {
  code: string;
  name: string;
  enabled: boolean;
  countryCode: string;
  phoneNoRegexSyntax: string | null;
}

export interface GimacCountry {
  code: string;
  countryIsoCode: string;
  name: string;
  currencyCode: string;
  createdAt: string;
  updatedAt: string;
  participants: GimacParticipant[];
  telcos: GimacTelco[];
  billers: any[];
}
